function TransformationparamConfig(list) {
  if (!(list == null ? void 0 : list.length))
    return {};
  const resMap = list.reduce((map, item) => {
    map[item.attributeCode] = item.attributeValues;
    if (item.attributeCode === "faucetModel") {
      map["faucetModelDisplayValues"] = item.attributeDisplayValues;
    }
    return map;
  }, {});
  return resMap;
}
export { TransformationparamConfig };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/utils/TransformationparamConfig.js